import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ReasoningApi as ReasoningApiToken } from '../repositories/apis/reasoning-api.interface';
let ReasoningServiceImpl = class ReasoningServiceImpl {
    constructor(reasoningApi) {
        this.reasoningApi = reasoningApi;
        this.inflight = new Map();
    }
    async fetchReasoning(params) {
        const key = this.toKey(params);
        // 同 key 重复请求：先取消前一次
        this.cancel(key);
        const ctrl = new AbortController();
        this.inflight.set(key, ctrl);
        try {
            const resp = await this.reasoningApi.getReasoning({
                folder_id: params.folderId,
                field_id: params.fieldId,
                patent_id: params.patentId,
                signal: ctrl.signal,
            });
            return (resp?.reasoning ?? '').trim();
        }
        finally {
            // 当前 key 仍指向本次 controller 时才清理
            if (this.inflight.get(key) === ctrl) {
                this.inflight.delete(key);
            }
        }
    }
    cancel(key) {
        if (key) {
            const ctrl = this.inflight.get(key);
            if (ctrl) {
                ctrl.abort();
                this.inflight.delete(key);
            }
            return;
        }
        this.inflight.forEach(ctrl => ctrl.abort());
        this.inflight.clear();
    }
    saveAsComment(params) {
        return this.reasoningApi.checkPatentWithReasoning({
            folder_id: params.folderId,
            field_id: params.fieldId,
            patent_id: params.patentId,
            save_reasoning_as_comment: params.saveReasoningAsComment,
            comment_visible_scope: params.commentVisibleScope,
        });
    }
    toKey(params) {
        return `${params.folderId}|${params.fieldId}|${params.patentId}`;
    }
};
ReasoningServiceImpl = __decorate([
    injectable(),
    __param(0, inject(ReasoningApiToken)),
    __metadata("design:paramtypes", [Object])
], ReasoningServiceImpl);
export { ReasoningServiceImpl };
